module.exports = __webpack_public_path__ + "static/media/indoor_modbus_rtu_en.461d4da5.md";